import { Wrapper } from './InfoListRow.styled'

type InfoListRowProps = {
  dataTest?: string
}

const InfoListRow: React.FC<InfoListRowProps> = ({ children, dataTest }) => {
  return <Wrapper data-test={dataTest || 'InfoListRow'}>{children}</Wrapper>
}

export default InfoListRow
